import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export default function LinearLoading({ isLinearLoading }) {
    if (!isLinearLoading) return null;
    return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
  );
}
